import { useReward } from "api/rewards";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import "react-loading-skeleton/dist/skeleton.css";
import { useLocation } from "react-router-dom";
import { TranslationsBE } from "types/translations";
import { links } from "utilities/links";
import { RewardForm } from "./RewardForm";
import { useStyles } from "./RewardForm.styles";

export function AddReward() {
  const classes = useStyles();
  const { message } = useMessage();
  const { state } = useLocation();
  const { useRewardData } = useReward();
  const { data: rewardData } = useRewardData(
    state?.rewardToDuplicate as string,
  );

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "rewards" }),
      path: links.rewardsList,
    },
  };

  const initialValues = rewardData
    ? {
        ...rewardData,
        translations: rewardData.translations.map(
          (translation: TranslationsBE) => {
            return {
              ...translation,
              name: `COPY - ${translation.name}`,
            };
          },
        ),
      }
    : undefined;

  const isDataLoaded = state?.rewardToDuplicate ? !!initialValues : true;

  return (
    <>
      <TopHeader
        title={message({ id: "addReward" })}
        clearLink={links.rewardsList}
        breadcrumbs={breadcrumbs}
      />
      <div className={classes.formContainer}>
        {isDataLoaded && <RewardForm rewardData={initialValues} />}
      </div>
    </>
  );
}
